<template>
    <section class="card card-info card-outline mb-4 " role="region" id="profile-nowplaying">
        <div class="card-header">
            <div class="d-flex align-items-center">
                <h3 class="flex-shrink card-title my-0" key="lang_profile_nowplaying_onair" >On the Air</h3>
                <h6 class="card-subtitle text-right flex-fill my-0" style="line-height: 1;">
                     <i class="fa fa-headphones" aria-hidden="true"></i>
                    Listeners
                    <br>
                    <small>
                        <span>{{ listeners.unique }}</span>
                        Unique
                    </small>
                </h6>
            </div>
        </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="clearfix">
                            <h6 style="margin-left: 32px;" v-if="!empty(now_playing)">
                                <i class="fa fa-music" aria-hidden="true"></i>
                                Now Playing
                            </h6>
                           
                            <div class="media">
                                <a class="mr-2" v-if="current_track.art" :href="current_track.art" target="_blank">
                                    <img class="rounded" :src="current_track.art" alt="Album Art" style="width: 50px;">
                                </a>
                                <div class="media-body">
                                     <div v-if="!onAir">
                                        <h6 class="h6 media-heading m-0" style="line-height: 1;">
                                           Offline Stream
                                        </h6>
                                    </div>
                                    <div v-else-if="current_track.title !== ''">
                                        <h6 class="h6 media-heading m-0" style="line-height: 1;">
                                            {{ current_track.title }}<br>
                                            <small>{{ current_track.artist }}</small>
                                        </h6>
                                    </div>
                                    <div v-else>
                                        <h6 class="media-heading m-0" style="line-height: 1;">{{ current_track.text }}</h6>
                                    </div>
                                    <div v-if="now_playing.playlist">
                                        <small class="text-muted">Playlist: {{ now_playing.playlist }}</small>
                                    </div>
                                    <div class="nowplaying-progress" v-if="timeDisplay">
                                        <small>{{ timeDisplay }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                           <div class="clearfix" v-if="!live.is_live && !empty(next_playing)">
                            <h6 style="margin-left: 22px;">
                                <i class="fas fa-step-forward" aria-hidden="true"></i>

                                Playing Next
                            </h6>

                            <div class="media">
                                <a class="mr-2" v-if="next_track.art" :href="next_track.art"  target="_blank">
                                    <img :src="next_track.art" class="rounded" alt="Album Art" style="width: 40px;">
                                </a>
                                <div class="media-body">
                                    <div v-if="next_track.title !== ''">
                                        <h6 class="media-heading m-0" style="line-height: 1;">
                                            {{ next_track.title }}<br>
                                            <small>{{ next_track.artist }}</small>
                                        </h6>
                                    </div>
                                    <div v-else>
                                        <h6 class="media-heading m-0" style="line-height: 1;">{{ next_track.text }}</h6>
                                    </div>

                                    <div v-if="next_playing.playlist">
                                        <small class="text-muted">Playlist {{ next_playing.playlist }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix" v-else-if="live.is_live">
                            <h6 style="margin-left: 22px;">
                                 <i class="fas fa-microphone" aria-hidden="true"></i>
                                Live
                            </h6>

                            <h4 class="media-heading" style="margin-left: 22px;">
                                {{ live.streamer_name }}
                            </h4>
                        </div>
                    </div>
                </div>
                <!-- <div class="align-center" v-else>
                     <img src="/loading.svg" alt="" srcset="">
                </div> -->
            </div>
       
        <div class="card-footer">
        <div class="card-actions flex-shrink" v-if="onAir && userCanManageBroadcasting">
            <button :disabled="processing"  @click.prevent="backendSkip" id="btn_skip_song" class="btn btn-outline-info btn-sm" role="button" v-if="!live.is_live" >
                <i class="fas fa-step-forward" aria-hidden="true"></i>
               {{processing? 'skipping...':'Skip Track'}} 
            </button>

            <a id="btn_disconnect_streamer" class="btn btn-outline-info btn-sm" role="button" v-if="live.is_live" :href="backendDisconnectStreamerUri">
                <i class="fas fa-microphone-slash" aria-hidden="true"></i>
                Disconnect Streamer
            </a>
        </div>
        </div>
    </section>
</template>

<script>

import { SERVER_ACTION } from "@/store/action-types";
export default {

    data () {
        return {
            npElapsed: 0,
            clockInterval: null,
            userCanManageBroadcasting: true,
            backendDisconnectStreamerUri: '!#',
            skipTrackUri: 'admin/services/backend/skip',
        };
    },
    mounted () {
        this.clockInterval = setInterval(this.iterateTimer, 1000);
    },
    computed: {

        timeDisplay () {
            let time_played = this.npElapsed;
            let time_total = this.now_playing.duration;

            if (!time_total) {
                return null;
            }

            if (time_played > time_total) {
                time_played = time_total;
            }

            return this.formatTime(time_played) + ' / ' + this.formatTime(time_total);
        }
    },
    methods: {

         empty(obj){
          return Object.keys(obj).length == 0
       },

        iterateTimer () {
            let current_time = Math.floor(Date.now() / 1000);
            let np_elapsed = current_time - this.now_playing.played_at;
            if (np_elapsed < 0) {
                np_elapsed = 0;
            } else if (np_elapsed >= this.now_playing.duration) {
                np_elapsed = this.now_playing.duration;
            }

            this.npElapsed = np_elapsed;
        },
        formatTime (time) {
            let sec_num = parseInt(time, 10);

            let hours = Math.floor(sec_num / 3600);
            let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            let seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return (hours !== '00' ? hours + ':' : '') + minutes + ':' + seconds;
        },

       async backendSkip(){
         this.$store.dispatch(SERVER_ACTION, this.skipTrackUri)

        }
    }
};
</script>

